import React, { useEffect, useRef } from "react";
import "./queryTab.css";
import modeltabActive from "../../assets/icons/modeltabactive.svg";
import modeltabInactive from "../../assets/icons/modeltabInactive.svg";

const QueryTab = ({ activeTab, tabs, titleActions, onTabChange }: any) => {

  return (
    <>
      <div className="row g-3">
        <div className="col-md-3 d-flex">
          <div className="modelside-tab w-100 modelside-tab-wrapper">
            {tabs.map((tab: any) => (
              <button
                key={tab.key}
                data-key={tab.key}
                className={
                  tab.key === activeTab
                    ? "fs-6 p-2 position-relative border-0 side-tab-button active"
                    : "fs-6 p-2 position-relative border-0 side-tab-button inactive"
                }
                onClick={() => onTabChange(tab.key)}
              >
                <p
                  className={
                    tab.key === activeTab
                      ? "m-0 model-tab active d-flex justify-content-center align-items-center gap-2"
                      : "model-tab m-0 d-flex justify-content-center align-items-center gap-2"
                  }
                >
                  {/* Active icon */}
                  <img
                    src={modeltabActive}
                    alt="active"
                    className={`sidebar-icon active-icon ${tab.key === activeTab ? "visible" : "hidden"
                      }`}
                  />

                  {/* Inactive icon */}
                  <img
                    src={modeltabInactive}
                    alt="inactive"
                    className={`sidebar-icon inactive-icon ${tab.key === activeTab ? "hidden" : "visible"
                      }`}
                  />

                  {tab.title}
                </p>
              </button>

            ))}
          </div>
        </div>
        <div className="col-md-9 d-flex flex-column">
          <div className="">{titleActions}</div>
          <div className="models-list-wrapper w-100">
            {tabs.map(({ content, key }: { content: React.ReactNode; key: any }) => (
              <div key={key} style={{ display: activeTab === key ? "block" : "none" }}>
                {content}
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default QueryTab;
